import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { CFontIcon, CLink } from "@appcues/component-library";


const NavbarLink = ({
  id,
  href,
  iconComponent,
  icon,
  children,
  to,
  exact,
  onClick = null
}) => {
  let linkProps = {};

  const determineMatch = (match, location) => {
    if (match) {
      return true;
    } else if (location.pathname.includes("journeys") && to === "/flows") {
      return true;
    }

    return false;
  };

  if (href && !href.includes("//")) {
    linkProps = {
      exact,
      isActive: determineMatch,
      to: href,
      is: NavLink,
      activeClassName: "active"
    };
  } else {
    linkProps = {
      href,
      target: "_blank"
    };
  }

  return (
    <li>
      <StyledNavbarLink
        id={id}
        {...linkProps}
        role="menuitem"
        tabIndex="0"
        onClick={evt => onClick && onClick(evt)}
      >
        {(iconComponent || icon) && (
          <div className="nav-section-link-icon">
            {iconComponent || (
              <CFontIcon
                className={`fas fa-${icon} nav-section-link-icon`}
                altText={`${icon} icon`}
              />
            )}
          </div>
        )}
        <div className="nav-section-link-text">{children}</div>
      </StyledNavbarLink>
    </li>
  );
};

const StyledNavbarLink = styled(CLink)`
  display: flex;
  font-size: 14px;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 4px;
  font-weight: 600;
  font-smoothing: antialiased;
  cursor: pointer;
  text-decoration: none;

  &:focus,
  &:hover {
    .nav-section-link-text,
    .nav-section-link-icon {
      color: ${props => props.theme["$purple"]};
    }
  }

  &.active {
    .nav-section-link-icon,
    .nav-section-link-text {
      color: ${props => props.theme["$purple"]};
    }
  }

  .nav-section-link-text {
    transition: color 0.2s ease;
    color: ${props => props.theme["$blue-gray-2"]};
    font-weight: 400;
  }

  .nav-section-link-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 30px;
    height: 30px;
    color: ${props => props.theme["$gray-30"]};
    font-size: 14px;

    margin-right: 5px;
    margin-left: 5px;

    transition: color 0.2s ease;

    img {
      border-radius: 40px;
      padding: 4px;
      max-width: 100%;
      max-height: 100%;
    }
  }
`;

export default NavbarLink;
